import * as type from '../types';

const initialState = {
  sidemenu: false,
  serverTime: '',
  serverTimeInitial: '',
};

export default function utilities(state = initialState, action) {
  switch (action.type) {
    case type.SET_NAVBAR_TOGGLE:
      return {
        ...state,
        sidemenu: !state.sidemenu,
      };
    case type.SET_SERVER_TIME:
      return {
        ...state,
        serverTime: action.payload,
        serverTimeInitial: action.payload,
      };
    case type.TICK_SERVER_TIME:
      return {
        ...state,
        serverTime: action.payload,
      };
    default:
      return state;
  }
}
